import {
    Box,
    Center,
    Flex,
    Image,
    Input,
    InputGroup,
    InputLeftElement,
    SimpleGrid,
    Spinner,
    Text,
    useDisclosure,
} from '@chakra-ui/react';
import { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { AiOutlineShoppingCart } from 'react-icons/ai';
import ProductItem from 'components/Store/ProductItem';
import StoreBg1 from 'assets/store_bg_1.jpg';
import StoreBg2 from 'assets/store_bg_2.jpg';
import { search } from '../dashboard/components/Icons';
import { useEffect } from 'react';
import { fetchStoreInfo, updateStoreCart } from 'redux/actions/storefrontActions';
import AddToStorefrontCartModal from 'components/Store/AddToStorefrontCartModal';
import { addToStoreCart } from 'utils/utils';
import { toast } from 'react-hot-toast';

export default function StorePage() {
    const { pathname } = useLocation();
    const { storeName } = useParams();
    const navigate = useNavigate();
    const [currentItem, setCurrentItem] = useState({});
    const {
        isOpen: isCartModalOpen,
        onOpen: openCartModal,
        onClose: closeCartModal,
    } = useDisclosure();
    const dispatch = useDispatch();
    const [products, setProducts] = useState([]);

    const { storefrontData, isLoading, cart } = useSelector((state) => state.storefrontReducer);

    const preAddToCart = (item) => {
        openCartModal();
        setCurrentItem(item);
    };

    const addToCart = () => {
        dispatch(updateStoreCart(addToStoreCart(cart, currentItem)));
        toast.success("Added to cart successfully");
        closeCartModal();
    }

    useEffect(() => {
        dispatch(fetchStoreInfo(storeName));
        const cartData = JSON.parse(localStorage.getItem("store_cart") || "{}");
        if (Object.keys(cartData).length) {
          dispatch(updateStoreCart(cartData));
        }
    }, [dispatch, storeName]);

    useEffect(() => {
        setProducts(storefrontData?.products?.items);
    }, [storefrontData]);

    if (isLoading) {
        return (
            <Center mt="20">
                <Spinner size="xl" thickness="4px" />
            </Center>
        );
    }

    return (
        <>
            <Box mx="auto" as="section" maxW={{ sm: '95%', xl: '1400px' }}>
                <SimpleGrid columns={3} gap={{ sm: '4', lg: '40' }} py="5">
                    <Box my="auto">
                        <Box display={{ sm: 'block', lg: 'none' }}>{search}</Box>
                        <InputGroup
                            display={{ sm: 'none', lg: 'block' }}
                            overflow="hidden"
                            bg="#FFFFFF"
                            border="0.3px solid #DEDEDE"
                            borderRadius="8px"
                            h="40px">
                            <InputLeftElement pl="10px" h="full" pointerEvents="none" opacity=".3">
                                {search}
                            </InputLeftElement>
                            <Input
                                type="text"
                                placeholder="Search"
                                h="full"
                                inputMode="search"
                                border="none"
                                fontSize="13px"
                                _placeholder={{ color: '#999999' }}
                            />
                        </InputGroup>
                    </Box>
                    <Box m="auto">
                        <Text
                            textAlign="center"
                            textTransform="capitalize"
                            fontSize="2xl"
                            fontWeight="medium">
                            {`${storefrontData?.name}'s Storefront`}
                        </Text>
                    </Box>
                    <Box ml="auto" my="auto">
                        <Flex
                            fontSize="xl"
                            cursor="pointer"
                            alignItems="center"
                            onClick={() => navigate(`${pathname}/cart`)}>
                            <Text letterSpacing="wide">Cart</Text>
                            &nbsp;
                            <Text>
                                <AiOutlineShoppingCart />
                            </Text>
                            <Text as="sup" bg="blue.500" borderRadius="full" color="white" p="2.5">{cart?.length}</Text>
                        </Flex>
                    </Box>
                </SimpleGrid>
                <SimpleGrid columns="2" mb="8">
                    <Image
                        src={StoreBg1}
                        w="full"
                        maxH="300px"
                        objectFit="cover"
                        borderTopLeftRadius="2xl"
                        borderBottomLeftRadius="2xl"
                    />
                    <Image
                        src={StoreBg2}
                        w="full"
                        maxH="300px"
                        objectFit="cover"
                        borderTopRightRadius="2xl"
                        borderBottomRightRadius="2xl"
                    />
                </SimpleGrid>
                <Text mb="3" fontWeight="medium" fontSize="xl">
                    Popular
                </Text>
                <SimpleGrid columns={{ sm: '2', lg: '3', xl: '5' }} gap="5">
                    {products?.length ? products.map((item) => (
                        <ProductItem key={item.id} preAddToCart={preAddToCart} item={item} />
                    )) : <Text>No products found</Text>}
                </SimpleGrid>
            </Box>
            <AddToStorefrontCartModal
                isOpen={isCartModalOpen}
                onClose={closeCartModal}
                addToCart={addToCart}
            />
        </>
    );
}
